export const ImageWidth = "4.38rem";
export const ProgressUnit = "%";
